import { ReactElement } from 'react'
import { PlanTableForm } from '@structuralPlanningComponents'
import { Box, Typography } from '@mui/material'
import { usePlanTableStore } from '@editorStores'
import { useSelectedPlanElementId } from '@editorHooks'

/**
 * Drawer shown next to the tables list (only while the "Tabellen" tab is active). It surfaces the
 * selected table's settings in PlanTableForm. With no table selected it prompts the user to pick
 * one.
 */
const PlanTableDrawer = (): ReactElement => {
  const selectedId = useSelectedPlanElementId('table')
  const selectedTable = usePlanTableStore(state =>
    selectedId ? state.tables.find(table => table.id === selectedId) : undefined,
  )

  if (!selectedTable) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary" data-cy="plan-table-drawer-empty">
          Bitte eine Tabelle auswählen
        </Typography>
      </Box>
    )
  }

  return <PlanTableForm />
}

export default PlanTableDrawer
